import React, {useEffect, useState} from 'react';
import BackHeader from '@comp/BackHeader/index';
import DocHeader from './components/DocHeader';
import DocGoodsAt from './components/DocGoodsAt';
import {fetchDocInfo} from '@/store/api/doctor';

import './index.less';

const Doctor = function (props) {
  const {id} = props.match.params;

  const [docInfo, setDocInfo] = useState({});

  useEffect(() => {
    queryDocInfo();
  }, []);

  const queryDocInfo = async () => {
    const data = await fetchDocInfo({
      doctor_id: id,
    });

    setDocInfo(data);
  };

  return (
    <div className="doctor-page">
      <BackHeader title={'医生主页'} />
      <DocHeader data={docInfo} />
      <article>排班</article>
      <DocGoodsAt className="section" data={docInfo.doc2disease_list} />
      <section>执业经历</section>
      <section>患者口碑</section>
      <section>医生推荐</section>
      <section>在线咨询</section>
      <section>tip</section>
      <section>推荐</section>
    </div>
  );
};

export default Doctor;
